<script setup lang="ts">
// Shown the instant a Pilotage section is opened, while its code is still on
// the way (first visit; the layout preloads every section in the background
// after it mounts, so this is mostly the very first click). The frame above —
// title, referentials and evaluation blocks — is already on screen: this stands
// in for the content only (MYAC-1522 3b, Aymeric 2026-10-07: « passer sur
// l'autre page immédiatement et avoir un loader / skeleton »).
import Skeleton from 'primevue/skeleton'
</script>

<template>
  <div class="flex flex-col gap-3 p-4" data-testid="pilotage-section-skeleton" aria-busy="true">
    <div class="flex items-center gap-2">
      <Skeleton width="6rem" height="1.75rem" border-radius="6px" />
      <Skeleton width="6rem" height="1.75rem" border-radius="6px" />
      <Skeleton width="6rem" height="1.75rem" border-radius="6px" />
    </div>
    <Skeleton width="10rem" height="0.9rem" />
    <Skeleton v-for="i in 6" :key="i" height="2.75rem" border-radius="8px" />
  </div>
</template>
